import { useEffect } from 'react';

/**
 * Custom hook to manage overflow styles on a ref element
 * @param {React.RefObject} ref - The ref object pointing to the element
 * @param {boolean} condition - When true, sets overflow to 'hidden', otherwise 'auto'
 * @param {string} hiddenValue - Value to set when condition is true (default: 'hidden')
 * @param {string} visibleValue - Value to set when condition is false (default: 'auto')
 */
export const useDisableOverflow = (
  ref: React.RefObject<HTMLDivElement>,
  condition: boolean,
  hiddenValue = 'hidden',
  visibleValue = 'auto'
) => {
  useEffect(() => {
    if (!ref?.current) return;

    if (condition) {
      ref.current.style.overflow = hiddenValue;
    } else {
      ref.current.style.overflow = visibleValue;
    }
  }, [ref, condition, hiddenValue, visibleValue]);
};
